import { CreateCompetenciesCompetencyOptionsInput } from 'generated/resources/graphql'

export const generateOptionsByRange = (range: [number, number]) =>
  [...Array(range[1] - range[0] + 1).keys()].map((x) => ({
    value: range[0] + x,
    position: range[0] + x,
  }))

export const defaultRange = (): [number, number] => [
  RatingDefaultValues.minValue,
  RatingDefaultValues.maxValue,
]

type Options =
  | CreateCompetenciesCompetencyOptionsInput[]
  | CreateCompetenciesCompetencyOptionsInput[]

export const rangeFromOptions = (options: Options): [number, number] => {
  if (options.length < 1) return defaultRange()

  const values = options
    .map((option) => option.value)
    .filter((value) => value !== null && value !== undefined)
    .sort((a, b) => a - b)

  const min = values[0]
  const max = values[values.length - 1]

  if (min === undefined || max === undefined || min === null || max === null) return defaultRange()

  return [min, max]
}

export enum RatingDefaultValues {
  minValue = 0,
  maxValue = 10,
}
